import LoginForm from '../forms/loginForm';
import RegistrationForm from '../forms/registrationForm';
import ResetPasswordForm from '../forms/resetPasswordForm';
import SetNewPasswordForm from '../forms/setNewPasswordForm';

export default class AppFormsController {
    #forms = {};

    constructor() {
        this.initForms();
    }

    initForms() {
        this.#forms.loginForm = new LoginForm();
        this.#forms.registrationForm = new RegistrationForm();
        this.#forms.resetPaswordForm = new ResetPasswordForm();
        this.#forms.setNewPasswordForm = new SetNewPasswordForm();
    }

    resetForms() {
        Object.values(this.#forms).forEach((form) => {
            form.resetFull();
        });
    }
}
